__turbopack_context__.v({
  "dark": "ygNOHa_dark",
  "widgetCloseBtn": "ygNOHa_widgetCloseBtn",
  "widgetPane": "ygNOHa_widgetPane",
  "widgetPaneContent": "ygNOHa_widgetPaneContent",
  "widgetPaneHeader": "ygNOHa_widgetPaneHeader",
  "widgetPaneOpen": "ygNOHa_widgetPaneOpen",
});
